import * as types from '../actions/types';

const initialState = {
    isErrorHandlerActive: false,
    errorHandlerMessage: '',
    errorHandlerTitle: '',
    errorHandlerOnlyCloseButton: false,
    isAuthenticating: true,
    isAuthenticated: false,
    cashierInfo: {},
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case types.AUTH_AUTHENTICATING_CHANGED: {
            return {
                ...state,
                isAuthenticating: payload,
            };
        }
        case types.AUTH_AUTHENTICATED_CHANGED: {
            return {
                ...state,
                isAuthenticated: payload,
                isAuthenticating: false,
            };
        }
        case types.AUTH_CASHIER_INFO_CHANGED: {
            return {
                ...state,
                cashierInfo: payload,
            };
        }
        case types.ERROR_HANDLING_SERVICES:
            return {
                ...state,
                isErrorHandlerActive: payload.visible,
                errorHandlerMessage: payload.message,
                errorHandlerTitle: payload.title,
                errorHandlerOnlyCloseButton: payload.onlyCloseButton,
            };
        default:
            return state;
    }
}
